import { Pipe, PipeTransform } from '@angular/core';
import { AnyObject, ItemMiddleAttrListDataSet, TableDataColumn } from '@mri/types';

@Pipe({
  name: 'tableCellMiddleClass'
})
export class TableDataSetMiddleClassPipe implements PipeTransform {

  transform(date: AnyObject, prop: ItemMiddleAttrListDataSet, column: TableDataColumn): string {
    if (typeof column.getMiddleClass === 'function') return column.getMiddleClass(prop);

    return '';
  }

}
